// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---content-contents-mdx": () => import("./../../../content/contents.mdx" /* webpackChunkName: "component---content-contents-mdx" */),
  "component---content-index-mdx": () => import("./../../../content/index.mdx" /* webpackChunkName: "component---content-index-mdx" */),
  "component---content-system-font-stacks-mdx": () => import("./../../../content/system_font_stacks.mdx" /* webpackChunkName: "component---content-system-font-stacks-mdx" */)
}

